import React, { useEffect, useState } from 'react'
import { FormFooterButton, InputCss } from '../../../helper/CommonFunction';
import { ApiHandler } from '../../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../../components/ModalComponets';
import { UploadImage } from '../../../helper/UploadFile';

const EditCategories = ({ isOpen, onClose, showData, setResetSearch, title }) => {
    const token = useSelector(state => state.user.userToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialState = {
        category_id: '',
        category_name: '',
    };

    const [formData, setFormData] = useState(initialState);
    const [imagePreview, setImagePreview] = useState(null); // Preview URL for UI
    const [uploadedImage, setUploadedImage] = useState(null); // Actual File
    const [isImageChanged, setIsImageChanged] = useState(false); // Track if user changed image
    const [isUploading, setIsUploading] = useState(false);

    const { category_id, category_name } = formData;

    useEffect(() => {
        if (showData) {
            setFormData({
                category_id: showData.id || '',
                category_name: showData.category_name || '',
            });
            setImagePreview(showData.category_image || null);
            setUploadedImage(null);
            setIsImageChanged(false);
        }
    }, [showData, isOpen]);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle Image Selection
    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagePreview(URL.createObjectURL(file));
            setUploadedImage(file);
            setIsImageChanged(true);
        }
    };

    // Reset Form on Close
    const handleClose = () => {
        setFormData(initialState);
        setImagePreview(null);
        setUploadedImage(null);
        setIsImageChanged(false);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let uploadedImageUrl = imagePreview?.split("/").pop(); // Default to existing image

        if (!category_name.trim()) {
            toast.error('Category name is required.');
            return;
        }

        if (isImageChanged && uploadedImage) {
            const uploadResponse = await UploadImage(uploadedImage, token, navigate);
            setImagePreview(`https://tezbikes.com/tezbike/assets/${uploadResponse}`);
            uploadedImageUrl = uploadResponse;
        }


        // Prepare form data
        const body = {
            category_id,
            category_name,
            category_image: uploadedImageUrl, // Use either new or existing image
        };

        try {
            const result = await ApiHandler('/edit_category.php', 'POST', body, token, dispatch, navigate)
            if (result.data.status === "1") {
                toast.success(result?.data.msg)
                handleClose();
                setResetSearch(true);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            handleClose();
        }
    };

    return (
        <ModalLarge isOpen={isOpen} title={title} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className="grid grid-cols-1 gap-y-4">
                    {/* Category Name */}
                    <div>
                        <label htmlFor="category_name" className="block text-[#222] font-semibold mb-1">
                            Category Name
                        </label>
                        <input
                            type="text"
                            name="category_name"
                            value={category_name}
                            placeholder="Enter category name"
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>

                    {/* Category Image Upload */}
                    <div>
                        <label htmlFor="category_image" className="block text-[#222] font-semibold mb-1">
                            Category Image
                        </label>
                        {imagePreview && (
                            <div className="mt-2">
                                <img src={imagePreview} alt="Preview" className="w-28 h-28 rounded-md border object-contain" />
                            </div>
                        )}
                        <input
                            type="file"
                            name="category_image"
                            accept="image/*"
                            onChange={handleImageUpload}
                            className="border rounded-md p-2 w-full mt-2"
                        />
                    </div>
                </div>

                {/* Submit Button */}
                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    )
}

export default EditCategories;
